module.exports = __webpack_public_path__ + "static/media/4-IMG_6756.7f2fcbb7.JPG";